import RecipientsInput from './RecipientsInput';
import i18n from './i18n';

export { i18n };
export * from './SelectedRecipientItem';
export * from './SelectedRecipients';
export * from './focusCampo';
export default RecipientsInput;
